import React, { ComponentType } from 'react';
import { SvgIconProps } from 'ui/icons/SvgIcon';

export enum NavBarVariant {
  Focus = 'focus',
  Edit = 'edit',
}

export interface NavBarProps {
  /** Unique ID for NavBar */
  id?: string;
  /** Custom icon for Back button */
  BackIcon?: ComponentType<SvgIconProps>;
  /** Custom icon for Menu button */
  MenuIcon?: ComponentType<SvgIconProps>;
  /** Callback for back button click */
  onBackClick?: () => void;
  /** Callback for hamburger button click */
  onMenuClick?: () => void;
  /** Content for the left side of the Nav */
  ContentLeft?: React.ReactNode;
  /** Content for the right side of the Nav */
  ContentRight?: React.ReactNode;
  /** Ref for hamburger button */
  menuRef?: React.RefObject<HTMLButtonElement>;
  /** Show the chat button for ADA/Zendesk support chat */
  showChatButton?: boolean;
  /** Title to display */
  title?: string;
  /** Variant of the NavBar */
  variant?: NavBarVariant;
}
